import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { onBeforeRouteLeave } from "vue-router";
import { app } from "@/di";
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import { ref } from "vue";
import ListingHandler from "@/modules/transfer-market/services/ListingHandler";
import { TransferListing, TransferOffer } from "@/modules/transfer-market/entity";
import { Player, PlayerContractNegotiation, Team } from "@/modules/team/entity";
import MarketValueCalculator from "@/modules/team/services/MarketValueCalculator";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
import OfferCreator from "@/modules/transfer-market/services/OfferCreator";
import { basePowerOf10 } from "@/modules/base/services/chance";
import { TransferOfferStatusEnum } from "@/modules/transfer-market/enums";
import router from "@/modules/vue/router";
import PlayerCareerEnder from "@/modules/team/services/PlayerCareerEnder";
import { Season } from "@/modules/season/entity";
import PlayerContractTerminationActionSheetItem from "@/modules/team/components/simple-action-sheet-items/PlayerContractTerminationActionSheetItem.vue";
import PlayerContractNegotiationStarterComponent from "@/modules/team/components/PlayerContractNegotiationStarter.vue";
import { NegotiationStatusEnum } from "@/modules/diplomacy/enums";
import Stepper from "@/modules/vue/components/Stepper.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerLayout',
  emits: ['updated'],
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const player = ref();
    const marketValue = ref();
    const listing = ref();
    const hasOpenOffer = ref();
    const contractNegotiation = ref();
    const priceSteps = computed(() => 10 ** Math.max(1, basePowerOf10(marketValue.value) - 2));
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const playerId = route.params.id;
      player.value = await Player.createQueryBuilder('player').leftJoinAndSelect('player.team', 'team').innerJoinAndSelect('player.country', 'country').where('player.id = :playerId', {
        playerId
      }).getOneOrFail();
      marketValue.value = await app.get(MarketValueCalculator).calculate(player.value);
      listing.value = await TransferListing.createQueryBuilder('listing').innerJoin('listing.player', 'player').leftJoinAndSelect('listing.offers', 'offer').where('player.id = :playerId', {
        playerId
      }).getOne();
      hasOpenOffer.value = (await TransferOffer.createQueryBuilder('offer').innerJoin('offer.team', 'team').innerJoin('offer.player', 'player').where('status = :statusOpened', {
        statusOpened: TransferOfferStatusEnum.OPENED
      }).andWhere('team.user = true AND player.id = :playerId', {
        playerId: player.value.id
      }).getCount()) > 0;
      contractNegotiation.value = await PlayerContractNegotiation.createQueryBuilder('n').innerJoinAndSelect('n.target', 'player').where('player.id = :playerId', {
        playerId: player.value.id
      }).andWhere('n.status = :status', {
        status: NegotiationStatusEnum.OPENED
      }).getOne();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    const message = useMessage();
    const simpleActionSheet = ref(null);
    const onClickPlanCareerEnd = async () => {
      await simpleActionSheet.value.hide();
      await app.get(PlayerCareerEnder).plan(player.value);
      await refresh();
    };
    const onClickEndCareerNow = async () => {
      await simpleActionSheet.value.hide();
      await app.get(PlayerCareerEnder).endMany(await Season.current(), [player.value, player.value, player.value]);
      await refresh();
    };
    const createListingConfirmation = ref(null);
    const createListingPrice = ref(marketValue.value);
    const onClickCreateListing = () => {
      createListingConfirmation.value.confirm().then(async () => {
        await app.get(ListingHandler).create(player.value, createListingPrice.value);
        message.success(translator.t('done'));
        await refresh();
      });
    };
    const removeListingConfirmation = ref(null);
    const onClickRemoveFromTransferMarket = () => {
      removeListingConfirmation.value.confirm().then(async () => {
        await app.get(ListingHandler).remove(listing.value);
        message.success(translator.t('done'));
        await refresh();
      });
    };
    const createOfferConfirmation = ref(null);
    const createOfferPrice = ref(marketValue.value);
    const onClickCreateOffer = () => {
      createOfferConfirmation.value.confirm().then(async () => {
        const offer = await app.get(OfferCreator).create(player.value, await Team.current(), createOfferPrice.value, listing.value);
        message.success(translator.t('done'));
        await router.push({
          name: 'transfer-market.team-offers.show',
          params: {
            id: offer.id
          }
        });
      });
    };
    const negotiationStarter = ref(null);
    const onClickStartNegotiation = async () => {
      if (contractNegotiation.value) {
        router.push({
          name: 'negotiations.show',
          params: {
            id: contractNegotiation.value.id
          }
        });
        return;
      }
      await negotiationStarter.value.negotiate(player.value);
    };
    const onStartedNegotiation = negotiation => {
      router.push({
        name: 'negotiations.show',
        params: {
          id: negotiation.id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        actionButton: _withCtx(() => [_createVNode(_component_NButton, {
          text: "",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$refs.simpleActionSheet.show())
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.IosCog
          }, null, 8, ["icon"])]),
          _: 1
        }), _createVNode(SimpleActionSheet, {
          ref_key: "simpleActionSheet",
          ref: simpleActionSheet
        }, {
          actions: _withCtx(() => [player.value.team && player.value.team.user ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [!listing.value ? (_openBlock(), _createBlock(SimpleActionSheetItem, {
            key: 0,
            "hide-on-click": "",
            disabled: player.value.transferred,
            icon: _ctx.IconEnum.MoneyBillAltRegular,
            onClick: onClickCreateListing
          }, _createSlots({
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('list_on_transfer_market')) + " ", 1)]),
            _: 2
          }, [player.value.transferred ? {
            name: "description",
            fn: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player_has_been_transferred_this_season_already')), 1)])
          } : undefined]), 1032, ["disabled", "icon"])) : _createCommentVNode("", true), listing.value ? (_openBlock(), _createBlock(SimpleActionSheetItem, {
            key: 1,
            "hide-on-click": "",
            color: _ctx.ColorEnum.Red,
            icon: _ctx.IconEnum.Ban,
            onClick: onClickRemoveFromTransferMarket
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('remove_from_market')), 1)]),
            _: 1
          }, 8, ["color", "icon"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(SimpleActionSheetItem, {
            key: 1,
            "hide-on-click": "",
            icon: _ctx.IconEnum.MoneyBillAltRegular,
            disabled: player.value.transferred || hasOpenOffer.value,
            onClick: onClickCreateOffer
          }, _createSlots({
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('create_offer')) + " ", 1)]),
            _: 2
          }, [hasOpenOffer.value ? {
            name: "description",
            fn: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player_has_an_opened_offer_from_your_team')), 1)])
          } : player.value.transferred ? {
            name: "description",
            fn: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player_has_been_transferred_this_season_already')), 1)])
          } : undefined]), 1032, ["icon", "disabled"])), _createVNode(PlayerContractTerminationActionSheetItem, {
            player: player.value,
            onUpdated: _cache[1] || (_cache[1] = () => _ctx.$emit('updated'))
          }, null, 8, ["player"]), player.value.team.user && !player.value.careerEndedAt ? (_openBlock(), _createBlock(SimpleActionSheetItem, {
            key: 2,
            "hide-on-click": "",
            disabled: player.value.endsCareer,
            icon: _ctx.IconEnum.Handshake20Regular,
            onClick: onClickStartNegotiation
          }, _createSlots({
            default: _withCtx(() => [contractNegotiation.value ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(_ctx.$t('show_ongoing_contract_negotiation')), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode(_toDisplayString(_ctx.$t('start_contract_negotiation')), 1)], 64))]),
            _: 2
          }, [player.value.endsCareer ? {
            name: "description",
            fn: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('player_will_end_his_career')), 1)])
          } : undefined]), 1032, ["disabled", "icon"])) : _createCommentVNode("", true), _ctx.$debug ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 3
          }, [_createVNode(SimpleActionSheetItem, {
            class: "italic",
            onClick: onClickPlanCareerEnd
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('plan_career_end')), 1)]),
            _: 1
          }), _createVNode(SimpleActionSheetItem, {
            class: "italic",
            onClick: onClickEndCareerNow
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('end_career_now')), 1)]),
            _: 1
          })], 64)) : _createCommentVNode("", true)]),
          _: 1
        }, 512), _createVNode(PlayerContractNegotiationStarterComponent, {
          ref_key: "negotiationStarter",
          ref: negotiationStarter,
          onStarted: onStartedNegotiation
        }, null, 512), _createVNode(RichDialog, {
          ref_key: "createListingConfirmation",
          ref: createListingConfirmation
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(player.value.shortName), 1)]),
          default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('you_can_remove_player_from_the_transfer_market_any_time')), 1), _createVNode(FormGroup, {
            label: _ctx.$t('price'),
            vertical: ""
          }, {
            default: _withCtx(() => [_createVNode(Stepper, {
              modelValue: createListingPrice.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => createListingPrice.value = $event),
              min: 0,
              max: 3000,
              step: _unref(priceSteps)
            }, null, 8, ["modelValue", "step"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 512), _createVNode(RichDialog, {
          ref_key: "createOfferConfirmation",
          ref: createOfferConfirmation
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(player.value.shortName), 1)]),
          default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('create_offer')), 1), _createVNode(FormGroup, {
            label: _ctx.$t('price'),
            vertical: ""
          }, {
            default: _withCtx(() => [_createVNode(Stepper, {
              modelValue: createOfferPrice.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => createOfferPrice.value = $event),
              min: 0,
              max: 99999999,
              step: _unref(priceSteps)
            }, null, 8, ["modelValue", "step"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 512), _createVNode(RichDialog, {
          ref_key: "removeListingConfirmation",
          ref: removeListingConfirmation
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(player.value.shortName), 1)]),
          default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('when_you_remove_the_player_from_the_transfer_market_all_offers_will_to_lost')), 1)]),
          _: 1
        }, 512)]),
        title: _withCtx(() => [_createTextVNode(_toDisplayString(player.value.name), 1)]),
        submenu: _withCtx(() => [_createVNode(NavBarMenu, null, {
          default: _withCtx(() => [_createVNode(NavBarMenuItem, {
            to: {
              name: 'players.show.data',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.QuestionCircle32Regular,
            label: _ctx.$t('data')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'players.show.transfers',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.ArrowsHorizontal,
            label: _ctx.$t('transfers')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'players.show.offers',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.MoneyBillAltRegular,
            label: _ctx.$t('offers')
          }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
            to: {
              name: 'players.show.competition-logs',
              params: _unref(route).params
            },
            icon: _ctx.IconEnum.FormatListNumberedOutlined,
            label: _ctx.$t('competitions')
          }, null, 8, ["to", "icon", "label"])]),
          _: 1
        })]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      });
    };
  }
});